import { OmegaComponent, device } from '@omegagrid/core';
import { css } from 'lit';
import { property } from 'lit/decorators.js';
import { Container } from '../container';
export class HostEvent extends Event {
	constructor(type: string) {
		super(`host.${type}`);
	}

}

export class Host extends OmegaComponent {

	static styles = [css`
		:host { display: block; height: 100% }
		* { box-sizing: border-box }
	`];

	@property({type: Object})
	container: Container;

	private _compact: boolean;
	set compact(value: boolean) {
		this._compact = value;
	}

	get compact() {
		if (this._compact == null) {
			this._compact = device.detect() === 'mobile';
		}
		return this._compact;
	}

}
